import core from "@/helpers/client";
const logService = {
  async readLogCodeInfo(log_code) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/logcodes/${log_code}?no-cache=1`
    );
    return result;
  },
  async readLogIdentifier(log_identifier_id, filterType) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_WATCHDOG}logs/${log_identifier_id}?filterType=${filterType}&no-cache=1`
    );
    return result;
  },
};
export default logService;
